export default function EmptyCart() {
  return (
    <div className="empty-cart">
      <img src="./assets/images/illustration-empty-cart.svg" alt="cake" />
      <span>Your added items will appear here</span>
    </div>
  );
}
